import { useState } from 'react';
import { Column, ConfirmationModal, RichTextEditor, TextField, Typography } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { normalizeDescription } from 'seagull/utils/richText';
import styles from "./EditServiceContentModal.module.scss";
import { EditServiceContentModalTestIds } from "./EditServiceContentModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EditServiceContentModal = _ref => {
  let {
    providedServiceName,
    providedServiceDescription,
    title,
    dismissModal,
    onSave,
    width
  } = _ref;
  const [serviceName, setServiceName] = useState(providedServiceName);
  const [serviceDescription, setServiceDescription] = useState(providedServiceDescription);
  const onDescriptionChange = description => {
    setServiceDescription(normalizeDescription(description));
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    width: width,
    "data-testid": EditServiceContentModalTestIds.EditServiceModal(),
    title: title,
    content: /*#__PURE__*/_jsxs(Column, {
      className: styles.modalContent,
      children: [/*#__PURE__*/_jsx(TextField, {
        type: "text",
        id: "serviceName",
        name: "serviceName",
        label: "Service Name",
        value: serviceName,
        onChange: e => {
          setServiceName(e.target.value);
        },
        textColor: colors.dark900,
        "data-testid": EditServiceContentModalTestIds.EditServiceNameInput()
      }), /*#__PURE__*/_jsxs(Column, {
        className: styles.serviceDescriptionWrapper,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          children: "Service description"
        }), /*#__PURE__*/_jsx(RichTextEditor, {
          className: styles.serviceDescription,
          editorHeight: 310,
          placeholder: "Describe service (Optional)",
          "data-testid": EditServiceContentModalTestIds.EditServiceDescriptionInput(),
          initialValue: serviceDescription,
          onChange: v => {
            onDescriptionChange(v);
          }
        })]
      })]
    }),
    onPrimaryButtonClick: () => onSave({
      name: serviceName,
      description: serviceDescription
    }),
    onSecondaryButtonClick: () => dismissModal(),
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    primaryButtonTestid: EditServiceContentModalTestIds.EditServiceModalSaveButton()
  });
};
export default EditServiceContentModal;